import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useGeo } from '../context/GeoContext';
import '../styles/GeoConsentModal.css';

export default function GeoConsentModal({ open = false, onClose }) {
  const { status, geoEnabled, enableLocation, error } = useGeo();

  // Create a portal root dynamically if not present
  const modalRootId = 'geo-modal-root';
  let modalRoot = document.getElementById(modalRootId);
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = modalRootId;
    document.body.appendChild(modalRoot);
  }

  // Lock page scroll while the modal is open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // If coordinates appear (permission granted), close the modal automatically
  useEffect(() => {
    if (open && geoEnabled) onClose?.();
  }, [open, geoEnabled, onClose]);

  if (!open) return null;
  const busy = status === 'requesting';

  const modal = (
    <div className="geo-overlay" role="dialog" aria-modal="true" aria-labelledby="geo-modal-title">
      <div className="geo-modal">
        <h2 id="geo-modal-title" className="geo-title">Enable Location</h2>
        <p className="geo-text">
          This app relies on your approximate location to show nearby posts and surveys.
          Please enable location to continue.
        </p>

        {error && status !== 'requesting' && (
          <div className="geo-error">{String(error?.message || error)}</div>
        )}

        <div className="geo-actions">
          <button
            type="button"
            className="geo-btn geo-btn--primary"
            disabled={busy}
            onClick={async () => {
              const res = await enableLocation();
              if (res?.ok || geoEnabled) {
                try { localStorage.setItem('geoConsent', 'granted'); } catch (_) {}
                onClose?.();
              }
            }}
          >
            {busy ? 'Requesting…' : 'Enable location'}
          </button>
          <button
            type="button"
            className="geo-btn geo-btn--ghost"
            disabled={busy}
            onClick={() => onClose?.()}
          >
            Cancel
          </button>
        </div>

        <div className="geo-status">
          Status: <strong>{status}</strong>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, modalRoot);
}
